import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Combinaison from './components/Combinaison';
import Capacites from './components/Capacites';
import Parcours from './components/Parcours';
import Atelier from './components/Atelier';
import Avantages from './components/Avantages';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-parchment font-body text-ink antialiased paper-grain">
      <Header />
      <main>
        <Hero />
        <Combinaison />
        <Capacites />
        <Parcours />
        <Atelier />
        <Avantages />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}

export default App;
